export const viewClaimMetaData1: any[] = [
    {
        keys: "claimDate",
        label: "Claim Date",
        index: 1,
    },
    {
        keys: "claimType",
        label: "Claim Type",
        index: 2,
    },
    {
        keys: "distributorId",
        label: "Distributor ID",
        index: 3,
    },
    {
        keys: "distributorName",
        label: "Distributor Name",
        index: 4,
    },
];

export function viewClaimMetaData2(currencySymbol: string, status: string, claimType: string, typeOfExpense: string, statusConfig: any): any[] {
    const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
    const { claimTypes, claimSubTypes } = ConfigDictionary;
    const updatedStatusConfig = statusConfig.map((config: any) => ({
        ...config,
        id: config.id?.toUpperCase(),
    }));

    const valueStyle = {
        fontSize: "15px",
        fontWeight: 600,
        color: "#C44C36",
        borderRadius: "8px",
        backgroundColor: "#FFFAF7",
        padding: "2px 6px"
    };

    switch (status) {
        case (updatedStatusConfig[1].id):
            if (claimType === claimTypes[0] || claimType === claimTypes[1]) {
                return [
                    {
                        keys: "noOfSkus",
                        label: typeOfExpense === claimSubTypes[3] ? "No. Of Invoices" : typeOfExpense === claimSubTypes[4] ? "No. Of Displays" : "No. Of SKUs",
                        index: 1,
                    },
                    {
                        keys: "totalQuantities",
                        label: "Claim Qty",
                        index: 2,
                    },
                    {
                        keys: "claimAmount",
                        label: "Claim Amount",
                        index: 3,
                        currencySymbol: currencySymbol,
                        valueType: "Number",
                        valueStyle: valueStyle
                    },
                ];
            }
            else if (typeOfExpense === claimSubTypes[4]) {
                return [
                    {
                        keys: "noOfSkus",
                        label: "No. Of Displays",
                        index: 1,
                    },
                    {
                        keys: "claimAmount",
                        label: "Claim Amount",
                        index: 3,
                        currencySymbol: currencySymbol,
                        valueType: "Number",
                        valueStyle: valueStyle
                    },
                ];
            }
            else if (typeOfExpense === claimSubTypes[5]) {
                return [
                    {
                        keys: "assetQty",
                        label: "Asset Qty",
                        index: 1,
                    },
                    {
                        keys: "claimAmount",
                        label: "Claim Amount",
                        index: 2,
                        currencySymbol: currencySymbol,
                        valueType: "Number",
                        valueStyle: valueStyle
                    }
                ];
            }
            else {
                return [
                    {
                        keys: "claimAmount",
                        label: "Claim Amount",
                        index: 1,
                        currencySymbol: currencySymbol,
                        valueType: "Number",
                        valueStyle: valueStyle
                    }
                ];
            }
        case updatedStatusConfig[0].id:
        case updatedStatusConfig[2].id:
        case updatedStatusConfig[3].id:
            if (claimType === claimTypes[0] || claimType === claimTypes[1]) {
                return [
                    {
                        keys: "totalQuantities",
                        label: "Claim Qty",
                        index: 1,
                    },
                    {
                        keys: "approvedTotalQuantities",
                        label: "Approved Qty",
                        index: 2,
                    },
                    {
                        keys: "claimAmount",
                        label: "Claim Amount",
                        index: 3,
                        currencySymbol: currencySymbol,
                        valueType: "Number"
                    },
                    {
                        keys: "approvedClaimAmount",
                        label: "Approved Claim Amount",
                        index: 4,
                        currencySymbol: currencySymbol,
                        valueType: "Number",
                        valueStyle: valueStyle
                    },
                ];
            }
            else if (typeOfExpense === claimSubTypes[5]) {
                return [
                    {
                        keys: "assetQty",
                        label: "Asset Qty",
                        index: 1,
                    },
                    {
                        keys: "assetApprovedQty",
                        label: "Approved Qty",
                        index: 2,
                    },
                    {
                        keys: "claimAmount",
                        label: "Claim Amount",
                        index: 3,
                        currencySymbol: currencySymbol,
                        valueType: "Number"
                    },
                    {
                        keys: "approvedClaimAmount",
                        label: "Approved Claim Amount",
                        index: 4,
                        currencySymbol: currencySymbol,
                        valueType: "Number",
                        valueStyle: valueStyle
                    },
                ];
            }
            else {
                return [
                    {
                        keys: "claimAmount",
                        label: "Claim Amount",
                        index: 1,
                        currencySymbol: currencySymbol,
                        valueType: "Number"
                    },
                    {
                        keys: "approvedClaimAmount",
                        label: "Approved Claim Amount",
                        index: 2,
                        currencySymbol: currencySymbol,
                        valueType: "Number",
                        valueStyle: valueStyle
                    },
                ];
            }
        default:
            return [
                {
                    keys: "claimAmount",
                    label: "Claim Amount",
                    index: 1,
                    currencySymbol: currencySymbol,
                    valueType: "Number"
                },
                {
                    keys: "approvedClaimAmount",
                    label: "Approved Claim Amount",
                    index: 2,
                    currencySymbol: currencySymbol,
                    valueType: "Number",
                    valueStyle: valueStyle
                },
            ];
    }
}
